import { DataResult, FilterDescriptor, State } from '@progress/kendo-data-query';
import app from '../client/app';
import { MessageType, QueryDashboardGridRequest, QueryDashboardGridResponse, QueryGridRequest, QueryGridResponse } from './actor-messages';

export function queryFlightsGrid(request: QueryGridRequest): Promise<QueryGridResponse> {
    return app.worker.actor.sendAsync({ type: MessageType.queryFlightsGrid, data: request });
}

export function queryDashboardCounts(filters: FilterDescriptor[][]): Promise<number[]> {
    return app.worker.actor.sendAsync({ type: MessageType.queryDashboardCounts, data: filters });
}

export function queryDashboardFlightsGrid(request: QueryDashboardGridRequest): Promise<QueryDashboardGridResponse> {
    return app.worker.actor.sendAsync({ type: MessageType.queryDashboardFlightsGrid, data: request });
}

export function queryAirportGrid(request: State): Promise<DataResult> {
    return app.worker.actor.sendAsync({ type: MessageType.queryAirportGrid, data: request });
}
